import {CallGroupType, GroupFilterType} from "@/api";
import {defineMessage, MessageDescriptor} from "react-intl";

export type GroupTypeDesc = {
    types: CallGroupType[];
    createTitle: MessageDescriptor;
    deleteNotification: MessageDescriptor;
    itemPath: string;
    pageTitle: string;
};

export const groupTypesDesc: {[K in GroupFilterType]: GroupTypeDesc | null} = {
    [GroupFilterType.CallGroup]: {
        types: [CallGroupType.Serial, CallGroupType.Parallel],
        createTitle: defineMessage({id: "new_call_group", defaultMessage: "New call group"}),
        deleteNotification: defineMessage({id: "call_group_deleted", defaultMessage: "Call group deleted"}),
        itemPath: "call-groups",
        pageTitle: "callGroups",
    },
    [GroupFilterType.CallQueue]: {
        types: [CallGroupType.CallQueue],
        createTitle: defineMessage({id: "new_call_queue", defaultMessage: "New call queue"}),
        deleteNotification: defineMessage({id: "call_queue_deleted", defaultMessage: "Call queue deleted"}),
        itemPath: "call-queues",
        pageTitle: "callQueues",
    },
    [GroupFilterType.Pickup]: null,
};

export const getGroupTypeDesc = (type: CallGroupType): GroupTypeDesc => {
    for (const desc of Object.values(groupTypesDesc)) {
        if (desc?.types.includes(type)) return desc;
    }
    throw Error(`No description found for group type ${type}`);
};
